<template>
  <div class="home">
    <NavigationBar />
    <Breadcrumb breadcrumbText="Food Menu" />
    <FoodMenu />
    <Video />
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationBar from "@/components/NavigationBar.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import FoodMenu from "@/components/FoodMenu.vue";
import Video from "@/components/Video.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "menu",
  components: {
    NavigationBar,
    Breadcrumb,
    FoodMenu,
    Video,
    Footer
  }
};
</script>
